
























































































































import JSEncrypt from "jsencrypt";
export default {
  name: "doctor-template",
  props: ["config"],
  data() {
    return {
      openEye: false,
      openQrcode: false,
      checked: false,
      formData: {
        loginAccount: "",
        loginCheckInfo: "",
      },
      formTest: {
        loginAccount: false,
        loginCheckInfo: false,
      },
      errorTip: "",
      errorPosition: "",
    };
  },
  computed: {
    next() {
      return (
        (this as any).checked &&
        !(this as any).errorTip &&
        Object.keys((this as any).formData).every(
          (key) => (this as any).formData[key]
        ) &&
        Object.keys((this as any).formTest).every(
          (key) => !(this as any).formTest[key]
        )
      );
    },
  },
  watch: {
    config: {
      handler(newCul: any) {
        const instance = this as any;
        instance.checked = newCul.protocolStatus;
      },
      immediate: true,
    },
    errorTip: {
      handler(newCul: any, oldCul: any) {
        const instance = this as any;
        if (!newCul && newCul !== oldCul) {
          const keyProp = Object.keys(instance.formTest).find(
            (key) => instance.formTest[key]
          );
          instance.test(keyProp);
        }
      },
    },
  },
  methods: {
    limit(key: string) {
      const instance = this as any;
      if (key === "loginAccount" && instance.formData[key].length > 11) {
        instance.formData[key] = instance.formData[key].slice(0, 11);
      }
    },
    test(key: string) {
      const instance = this as any;
      if (key === "loginCheckInfo") {
        const passwordReg = /^[0-9A-Za-z]{6,16}$/;
        if (!instance.formData.loginCheckInfo) {
          instance.errorTip = "请输入密码";
          instance.errorPosition = "loginCheckInfo";
          instance.formTest[key] = true;
        } else if (!passwordReg.test(instance.formData.loginCheckInfo)) {
          instance.errorTip = "请输入6-16位字母或数字的密码";
          instance.errorPosition = "loginCheckInfo";
          instance.formTest[key] = true;
        } else {
          instance.errorTip = "";
          instance.errorPosition = "";
          instance.formTest[key] = false;
        }
      }
      if (key === "loginAccount") {
        const phoneReg = /^[1][0-9]{10}$/;
        if (!instance.formData.loginAccount) {
          instance.errorTip = "请输入手机号";
          instance.errorPosition = "loginAccount";
          instance.formTest[key] = true;
        } else if (!phoneReg.test(instance.formData.loginAccount)) {
          instance.errorTip = "请输入正确的手机号码";
          instance.errorPosition = "loginAccount";
          instance.formTest[key] = true;
        } else {
          instance.errorTip = "";
          instance.errorPosition = "";
          instance.formTest[key] = false;
        }
      }
    },
    encryptDeal(msg: string) {
      const publicKey =
        "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKbpotLkdWJlxvWuydKwQkryMb3m2mZrj8tizRUbwBW9Bnyu0syIXz+IkxP6Z76b4cEO2NyEq5yPcJdaBKynSVcCAwEAAQ==";

      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(publicKey);
      return encrypt.encrypt(msg);
    },
    login() {
      const instance = this as any;
      if (!instance.next) return;
      const config = (this as any).config;
      const params = {
        account: (this as any).formData.loginAccount,
        checkInfo: instance.encryptDeal(instance.formData.loginCheckInfo),
        configId: config.id,
        source: "pc",
        userType: config.userType,
        type: "01",
      };
      (this as any).$emit("login-handle", params);
    },
    weixinLogin() {
      const config = (this as any).config;
      const params = {
        configId: config.id,
        source: "pc",
        userType: config.userType,
        registerFrom: String(config.registerFrom),
      };
      (this as any).$emit("weixin-login", params);
    },
    weiboLogin() {
      const config = (this as any).config;
      const params = {
        configId: config.id,
        source: "pc",
        userType: config.userType,
        registerFrom: String(config.registerFrom),
      };
      (this as any).$emit("weibo-login", params);
    },
    goRegister() {
      (this as any).$emit("go-register");
    },
    goForget() {
      (this as any).$emit("go-forget");
    },
    goUrl(url: string) {
      window.location.href = url;
    },
  },
};
